import React, { useEffect, useState } from "react";
import axios from "axios";
import { MyDomain } from "../../App";

export default function AdminShowAllApps() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  useEffect(() => {
    fetchAllApps();
  }, []);

  const fetchAllApps = async () => {
    try {
      const response = await axios.get(`${MyDomain}Appointments2/GetAllApps`);
      console.log("📋 All Apps Response:", response.data);
      setApps(response.data);
    } catch (error) {
      console.error("❌ Error fetching appointments:", error);
    } finally {
      setLoading(false);
    }
  };

  const filtered = apps.filter(
    (a) =>
      (a.name || "").toLowerCase().includes(search.toLowerCase()) ||
      (a.phoneNumber || "").includes(search) ||
      (a.date || "").includes(search) ||
      (a.barberPhoneNumber || "").includes(search),
  );

  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentApps = filtered.slice(startIndex, endIndex);

  const goToPage = (page) => setCurrentPage(page);
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  const goToPrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div style={styles.content}>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>

      <h2 style={styles.subtitle}>All Appointments ({filtered.length})</h2>

      <input
        type="text"
        placeholder="Search by name, phone, or date..."
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setCurrentPage(1);
        }}
        style={styles.searchInput}
      />

      {loading ? (
        <div style={styles.loadingContainer}>
          <div style={styles.spinner}></div>
          <p style={styles.loadingText}>Loading appointments...</p>
        </div>
      ) : (
        <>
          <div style={styles.tableContainer}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.headerRow}>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Barber Phone</th>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Start</th>
                  <th style={styles.th}>End</th>
                  <th style={styles.th}>Duration</th>
                  <th style={styles.th}>Phone</th>
                  <th style={styles.th}>Name</th>
                  <th style={styles.th}>Taken</th>
                  <th style={styles.th}>Barber Added</th>
                  <th style={styles.th}>With App ID</th>
                  <th style={styles.th}>Review</th>
                </tr>
              </thead>
              <tbody>
                {currentApps.length === 0 ? (
                  <tr>
                    <td colSpan="12" style={styles.noData}>
                      No appointments found
                    </td>
                  </tr>
                ) : (
                  currentApps.map((a) => (
                    <tr key={a.id} style={styles.row}>
                      <td style={styles.td}>{a.id}</td>
                      <td style={styles.td}>{a.barberPhoneNumber}</td>
                      <td style={styles.td}>
                        <span style={styles.dateText}>{a.date}</span>
                      </td>
                      <td style={styles.td}>{a.timeStart}</td>
                      <td style={styles.td}>{a.timeEnd}</td>
                      <td style={styles.td}>{a.timeLength} min</td>
                      <td style={styles.td}>{a.phoneNumber}</td>
                      <td style={styles.td}>{a.name}</td>
                      <td style={styles.td}>
                        <span
                          style={
                            a.isTaken === 1
                              ? styles.statusActive
                              : styles.statusInactive
                          }
                        >
                          {a.isTaken === 1 ? "Yes" : "No"}
                        </span>
                      </td>
                      <td style={styles.td}>{a.barberAddApp ?? "—"}</td>
                      <td style={styles.td}>{a.withAppId ?? "—"}</td>
                      <td style={styles.td}>{a.addReview ?? "—"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {filtered.length > 0 && (
            <div style={styles.paginationContainer}>
              <div style={styles.paginationInfo}>
                Showing {startIndex + 1} to{" "}
                {Math.min(endIndex, filtered.length)} of {filtered.length}{" "}
                appointments
              </div>

              <div style={styles.paginationButtons}>
                <button
                  onClick={goToPrevPage}
                  disabled={currentPage === 1}
                  style={{
                    ...styles.pageButton,
                    ...(currentPage === 1 ? styles.pageButtonDisabled : {}),
                  }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                  Previous
                </button>

                <div style={styles.pageNumbers}>
                  {[...Array(totalPages)].map((_, index) => {
                    const pageNumber = index + 1;
                    if (
                      pageNumber === 1 ||
                      pageNumber === totalPages ||
                      (pageNumber >= currentPage - 1 &&
                        pageNumber <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => goToPage(pageNumber)}
                          style={{
                            ...styles.pageNumberButton,
                            ...(currentPage === pageNumber
                              ? styles.pageNumberActive
                              : {}),
                          }}
                        >
                          {pageNumber}
                        </button>
                      );
                    } else if (
                      pageNumber === currentPage - 2 ||
                      pageNumber === currentPage + 2
                    ) {
                      return (
                        <span key={pageNumber} style={styles.ellipsis}>
                          ...
                        </span>
                      );
                    }
                    return null;
                  })}
                </div>

                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  style={{
                    ...styles.pageButton,
                    ...(currentPage === totalPages
                      ? styles.pageButtonDisabled
                      : {}),
                  }}
                >
                  Next
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

const styles = {
  content: {
    marginTop: "2rem",
    background: "rgba(255, 255, 255, 0.05)",
    backdropFilter: "blur(20px)",
    borderRadius: "16px",
    padding: "2rem",
    border: "1px solid rgba(255, 255, 255, 0.1)",
  },
  subtitle: {
    fontSize: "1.5rem",
    fontWeight: "600",
    color: "#ffffff",
    marginTop: 0,
    marginBottom: "1.5rem",
  },
  searchInput: {
    padding: "0.75rem 1rem",
    marginBottom: "1.5rem",
    width: "350px",
    background: "rgba(255, 255, 255, 0.08)",
    border: "1px solid rgba(167, 139, 250, 0.3)",
    borderRadius: "10px",
    color: "#ffffff",
    fontSize: "0.9rem",
    outline: "none",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "3rem",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "4px solid rgba(167, 139, 250, 0.2)",
    borderTopColor: "#a78bfa",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  loadingText: {
    color: "rgba(255, 255, 255, 0.6)",
    marginTop: "1rem",
    fontSize: "0.95rem",
  },
  tableContainer: {
    overflowX: "auto",
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.1)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "0.9rem",
  },
  headerRow: {
    background: "rgba(167, 139, 250, 0.1)",
  },
  th: {
    padding: "0.5rem 1rem",
    textAlign: "left",
    color: "#a78bfa",
    fontWeight: "600",
    borderBottom: "2px solid rgba(167, 139, 250, 0.3)",
    whiteSpace: "nowrap",
  },
  row: {
    borderBottom: "1px solid rgba(255, 255, 255, 0.05)",
    transition: "background 0.2s ease",
  },
  td: {
    padding: "0.4rem 1rem",
    color: "rgba(255, 255, 255, 0.8)",
    whiteSpace: "nowrap",
  },
  dateText: {
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: "0.875rem",
  },
  statusActive: {
    display: "inline-block",
    padding: "0.15rem 0.5rem",
    background: "rgba(34, 197, 94, 0.1)",
    color: "#86efac",
    borderRadius: "20px",
    fontSize: "0.8rem",
    fontWeight: "500",
  },
  statusInactive: {
    display: "inline-block",
    padding: "0.15rem 0.5rem",
    background: "rgba(239, 68, 68, 0.1)",
    color: "#fca5a5",
    borderRadius: "20px",
    fontSize: "0.8rem",
    fontWeight: "500",
  },
  noData: {
    textAlign: "center",
    padding: "2rem",
    color: "rgba(255, 255, 255, 0.5)",
    fontSize: "0.95rem",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "1.5rem",
    flexWrap: "wrap",
    gap: "1rem",
  },
  paginationInfo: {
    color: "rgba(255, 255, 255, 0.6)",
    fontSize: "0.875rem",
  },
  paginationButtons: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  pageButton: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.5rem 1rem",
    background: "rgba(167, 139, 250, 0.1)",
    border: "1px solid rgba(167, 139, 250, 0.3)",
    borderRadius: "8px",
    color: "#a78bfa",
    fontSize: "0.875rem",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  pageButtonDisabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    background: "rgba(255, 255, 255, 0.05)",
    borderColor: "rgba(255, 255, 255, 0.1)",
    color: "rgba(255, 255, 255, 0.4)",
  },
  pageNumbers: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
  },
  pageNumberButton: {
    width: "36px",
    height: "36px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "8px",
    color: "rgba(255, 255, 255, 0.6)",
    fontSize: "0.875rem",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  pageNumberActive: {
    background: "linear-gradient(135deg, #6366f1 0%, #a78bfa 100%)",
    borderColor: "#a78bfa",
    color: "#ffffff",
  },
  ellipsis: {
    color: "rgba(255, 255, 255, 0.4)",
    padding: "0 0.25rem",
  },
};
